var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMapPinIconOrange = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 33 41.457"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.504 20.352a3.682 3.682 0 002.705-1.127 3.7 3.7 0 001.123-2.709 3.682 3.682 0 00-1.127-2.705 3.7 3.7 0 00-2.709-1.123 3.682 3.682 0 00-2.705 1.127 3.7 3.7 0 00-1.123 2.709 3.681 3.681 0 001.127 2.705 3.7 3.7 0 002.709 1.123zm0 20.443a67.865 67.865 0 01-12-12.906q-4-5.972-4-10.966A15.7 15.7 0 015.251 5.042 15.725 15.725 0 0116.5.499a15.725 15.725 0 0111.253 4.543A15.7 15.7 0 0132.5 16.923q0 4.994-4 10.966a67.865 67.865 0 01-12 12.91z",
  fill: "#f96506",
  stroke: "#fff"
})));
export default __webpack_public_path__ + "static/map-pin-icon-orange.f9a59894b0ad2916750c7c9b69ebe539.svg";
export { SvgMapPinIconOrange as ReactComponent };